<template>
  <Breadcrumbs
      title="Edit Promotion"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Promotions', path: '/promotions' },
      { label: 'Edit Promotion', path: `/edit-promotion?promoId=${promoId}` }
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <!-- Pass promoId prop to form -->
      <editPromotionForm :promoId="promoId" />
    </div>
  </div>
</template>

<script>
import editPromotionForm from './edit_promotion_form.vue'

export default {
  name: 'editPromotion',
  components: {
    editPromotionForm,
  },
  computed: {
    promoId() {
      return this.$route.query.promoId; // read query param
    }
  }
}
</script>
